import React, { PureComponent } from 'react';
import { Modal, Tooltip, notification, message } from 'antd';
import { CopyOutlined, LoadingOutlined } from '@ant-design/icons';
import { connect } from 'react-redux';
import { isEmpty } from '../../../utilities/util';

const styles = {
  paymentLinkModalContent: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '20px',
  },
  text: {
    fontSize: '16px',
    margin: '10px 0px',
  },
};

class PaymentLinkModal extends PureComponent {
  static getDerivedStateFromProps(newProps) {
    const { paymentLinkDetails, onModalClose } = newProps;
    if (paymentLinkDetails) {
      const { error } = paymentLinkDetails;
      if (!isEmpty(error)) {
        message.error(JSON.stringify(error));
        onModalClose();
      }
    }
  }

  copyText = async (textToCopy) => {
    await navigator.clipboard.writeText(textToCopy);
    this.openNotificationWithIcon();
  };

  openNotificationWithIcon = () => {
    notification.success({
      message: 'Copied',
      description: 'Link has been copied to the clipboard',
    });
  };

  render() {
    const { paymentLinkDetails, visible, onModalClose } = this.props;
    const { sms_sent, email_sent, short_url } = paymentLinkDetails.data;
    const loading = paymentLinkDetails.isLoading;

    return (
      <Modal
        centered
        onCancel={onModalClose}
        destroyOnClose
        title="Payment Link"
        visible={visible}
        footer={null}
        maskClosable={false}
        bodyStyle={styles.paymentLinkModalContent}
      >
        {loading ? (
          <LoadingOutlined />
        ) : (
          <>
            <div>
              <div style={styles.text}>
                Payment Link :{' '}
                <a rel="noopener noreferrer" target="_blank" href={short_url}>
                  {short_url}
                </a>
              </div>
              <div style={styles.text}>
                Email sent : {email_sent ? 'Yes' : 'No'}
              </div>
              <div style={styles.text}>
                SMS sent : {sms_sent ? 'Yes' : 'No'}
              </div>
            </div>
            <Tooltip
              placement="bottomLeft"
              title="Click to copy"
              arrowPointAtCenter
            >
              <CopyOutlined
                style={{ fontSize: 32 }}
                onClick={() => this.copyText(short_url)}
              />
            </Tooltip>
          </>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state) => ({
  paymentLinkDetails: state.paymentLinks,
});

export default connect(mapStateToProps, {})(PaymentLinkModal);
